const _panicKey = 'F10'

const _panicButton = e => {
    if (e.altKey && e.ctrlKey && e.key === _panicKey)
        window.location.reload(true)
}

const _setPanicButton = () => {
    document.addEventListener('keyup', _panicButton)
}

const _removePanicButton = () => {
    window.removeEventListener('keyup', _panicButton)
}

export { _panicButton, _removePanicButton, _setPanicButton }
